"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var IconMessageFilled = function IconMessageFilled(_ref) {
  var style = _ref.style,
      className = _ref.className;
  return _react.default.createElement("svg", {
    width: "16px",
    height: "16px",
    className: (0, _classnames.default)('Icon', 'IconMessageFilled', className),
    style: style,
    viewBox: "0 0 16 16"
  }, _react.default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.79 11.199l-2.595 2.595A.7.7 0 0 1 0 13.299v-11.2C0 .94.94 0 2.1 0h9.799c1.16 0 2.1.94 2.1 2.1v7a2.1 2.1 0 0 1-2.1 2.099h-8.11z"
  }));
};

var _default = IconMessageFilled;
exports.default = _default;